export const useData = <T>(resolver: Promise<T> | (() => Promise<T>), defaultValue?: any) => {
	const state = useAsyncState<T>(resolver, defaultValue, {
		immediate: true,
		resetOnExecute: false
	});

	return state;
};
